import React from 'react';
import NursingTestCatalogManager from '../../head-doctor/nursing/NursingTestCatalogManager';
import { MAJOR_COPY } from '../majorCopy';

export default function MajorNursingTestsPage() {
  return <NursingTestCatalogManager copy={MAJOR_COPY.NURSING_TEST_CATALOG} />;
}
